export const PRELOAD_COMPLETE = 'PRELOAD_COMPLETE';
export function completePreload() {
  return {
    type: PRELOAD_COMPLETE,
  };
}
